import { MotifAccordion, MotifAccordionContent, MotifAccordionTrigger, MotifErrorMessage, MotifToast } from "@ey-xd/motif-react";
import {useTranslation} from 'react-i18next';
import { useFieldArray, useForm } from "react-hook-form";
import {  DEFAULT_CURRENCY_NAME, DEFAULT_DECIMAL_POINT, DEFAULT_DESCRIPTION, DEFAULT_EXCHANGE_RATE} from "./Constants";
import ControlInputBoxCurrency from "./ControlInputBoxCurrency";
import { useEffect, useState } from "react";
import { CurrencyConfigurationType } from "./type";
import Button from "@/components/Form/Button/Button";
import "./currencyConfiguration.scss";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { CurrencyRowType } from "../CaseSetupType";
import ControlInputBoxNumber from "./ControlInputBoxNumber";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/app/store";
import { resetCaseSetup, setCurrencyConfigurationData, updateFormSubmitIndex, updateStage } from "../caseSetupSlice";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { CANCEL_BUTTON_VARIANT, CREATE_BUTTON_VARIANT, NEXT_BUTTON_VARIANT, REMOVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import ControlInputBox from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";

 
export default function CurrencyConfiguration() {
    const [isVisible, setIsVisible] = useState(false);
    const [showMessage, setShowMessage] = useState({
        show: false,
        type: "error",
    });
    const CaseSetupData = useSelector(
        (state: RootState) => state.caseSetup
      );
      const dispatch = useDispatch();
    const {currencyConfiguration} = CaseSetupData;
    const formSubmitIndex = CaseSetupData.formSubmitIndex;
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [isFormOpen, setIsFormOpen] = useState(true);
    const [isFormOpenOrg, setIsFormOpenOrg] = useState(true);
    const {handleSubmit, control ,watch,formState: { errors }} = useForm<CurrencyConfigurationType>(
       {
        mode: 'onChange',
        defaultValues: {
            defaultCurrency: currencyConfiguration?.defaultCurrency || '',
            defaultExchangeRate: '1',
            defaultDecimalPoint: currencyConfiguration?.defaultDecimalPoint || '',
            defaultDescription: currencyConfiguration?.defaultDescription || '',
            fieldArray: currencyConfiguration?.fieldArray || []
        }
       }
    );

      const { fields, append, remove  } = useFieldArray({
        control,
        name: "fieldArray"
      });
      const watchFieldArray = watch("fieldArray");
    const onSubmit = async (data:CurrencyConfigurationType) => {
        dispatch(setCurrencyConfigurationData(data));
        dispatch(updateStage(3));
        formSubmitIndex !== 3 && dispatch(updateFormSubmitIndex(2));
    }
    const controlledFields = fields.map((field, index) => {
        return {
          ...field,
          ...watchFieldArray[index]
        };
      });
      
  const cancelBtnApproveHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsVisible(false);
    setShowMessage({...showMessage, show: false, type: "error"});
    dispatch(resetCaseSetup());
    navigate('/')
  }

  const cancelBtnRejectHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsVisible(false);
    setShowMessage({...showMessage, show: false, type: "error"});
    dispatch(setDiscardEditMode({ editMode: true }));

  }

const closeMessageHandler = () => { 
  setShowMessage({...showMessage, show: false, type: "error"});
}
useEffect(() => {
  dispatch(setDiscardEditMode({ editMode: true }));
  return () => {
    dispatch(setDiscardEditMode({ editMode: false }));
  };
}, [dispatch]);
const renderMessage = () => {
  if(showMessage.show && !isVisible) {
    window.scrollTo(0, 0);
    return (
      <MotifToast
        onClose={closeMessageHandler}
        //@ts-ignore
        variant={showMessage.type}
      > {showMessage.type === "error" ? t("global.globalNotifications.unExpectedError"): t("global.globalNotifications.updatedSuccessfully")} 
      </MotifToast>
    )
  }
}
      const addMoreCurrencyRow = () => {
        append({
            originalCurrency: "",
            originalExchangeRate: "",
            originalDecimalPoint: "",
            originalDescription: ""
        })
      }
      const removeCurrencyRow = (index: number) => {
        remove(index);
      }

      const renderCurrencyRow = (field :CurrencyRowType, index: number) => {
        return (
            <>
            <div className="motif-row heading pad-b-20 ">
                <div className="motif-col-lg-5">
                    {/**@ts-ignore */}
                    <ControlInputBoxCurrency key={field.id} name={`fieldArray.${index}.originalCurrency`} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.currencyName"} showLabel={true} />
                    {errors && errors?.fieldArray?.[index]?.originalCurrency && errors?.fieldArray?.[index]?.originalCurrency?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.CurrencyReq")}</MotifErrorMessage>}
                    {/* {errors && errors?.fieldArray?.[index]?.originalCurrency && errors?.fieldArray?.[index]?.originalCurrency?.type==="validate" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.defaultExchangeRateNumber")}</MotifErrorMessage>} */}
                </div>
                <div className="motif-col-lg-3">
                    <ControlInputBoxNumber key={field.id} name={`fieldArray.${index}.originalExchangeRate`} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.exchangeRate"} showLabel={true} readonly={false}/>
                    {errors && errors?.fieldArray?.[index]?.originalExchangeRate && errors?.fieldArray?.[index]?.originalExchangeRate?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.exchangeRateReq")}</MotifErrorMessage>}
                    {errors && errors?.fieldArray?.[index]?.originalExchangeRate && errors?.fieldArray?.[index]?.originalExchangeRate?.type==="validate" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.exchangeRateNumber")}</MotifErrorMessage>}
                </div>
                <div className="motif-col-lg-3">
                    <ControlInputBoxNumber key={field.id} name={`fieldArray.${index}.originalDecimalPoint`} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.decimalPoint"} showLabel={true} isNumber={true} integerOnly={true} decimalPlace={true}/>
                    {errors && errors?.fieldArray?.[index]?.originalDecimalPoint && errors?.fieldArray?.[index]?.originalDecimalPoint?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.decimalPointReq")}</MotifErrorMessage>}
                    {errors && errors?.fieldArray?.[index]?.originalDecimalPoint && errors?.fieldArray?.[index]?.originalDecimalPoint?.type==="validate" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.decimalPointNumberReq")}</MotifErrorMessage>}
                </div>
                <div className="motif-col-lg-11 mar-t-10">
                    <ControlInputBox name={`fieldArray.${index}.originalDescription`} control={control} required={false} isTextArea={true} label={"pages.caseSetup.currencyConfiguration.formLabels.description"} showLabel={true} readonly={false} charLimit={1000} />
                    {errors && errors?.fieldArray?.[index]?.originalDescription && errors?.fieldArray?.[index]?.originalDescription?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.decimalPointReq")}</MotifErrorMessage>}
                    {errors && errors?.fieldArray?.[index]?.originalDescription && errors?.fieldArray?.[index]?.originalDescription?.type==="validate" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.decimalPointNumberReq")}</MotifErrorMessage>}
                </div>
                <div className="motif-col-lg-11   ">
                    <Button type="button" variant={REMOVE_BUTTON_VARIANT} label={t("pages.caseSetup.currencyConfiguration.formLabels.remove")} onClickHandler={()=>{removeCurrencyRow(index)}}/>
                </div>

            </div>
            <hr></hr>
            </>
        );
      }
    return (
        <>
            {renderMessage() }
            <form onSubmit={handleSubmit(onSubmit)}>      
                <div className="motif-col-lg-12  main-container currency-configuration-container">
                    <div className="motif-row t-b-padding-21"> 
                        <div className="motif-col-xs-4">        
                            <p className='form-title'>{t("pages.caseSetup.currencyConfiguration.title")}</p>
                            <p className='form-description'>{t("pages.caseSetup.currencyConfiguration.description")}</p>
                        </div>
                    </div>
                    <div className="motif-row t-b-padding-21"> 
                        <div className="motif-col-xs-4"> 
                            <div
                            style={{
                                alignItems: 'flex-start',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '15px'
                            }}
                            >
                            
                                <MotifAccordion
                                onClose={()=>{setIsFormOpen(false)}}
                                onOpen={()=>{setIsFormOpen(true)}}
                                style={{
                                    flex: '1'
                                }}
                                open={isFormOpen}
                                useChevronIcon={true}
                                alignIconRight={true}
                                >
                                <MotifAccordionTrigger>
                                    {t("pages.caseSetup.currencyConfiguration.defaultCurrency")}
                                </MotifAccordionTrigger>
                                <MotifAccordionContent>
                                    <div className="motif-container pad-l-40 pad-r-20">
                                        <div className="motif-row heading"> 
                                            <div className="motif-col-lg-5">
                                            {/*@ts-ignore */}   
                                            <ControlInputBoxCurrency name={DEFAULT_CURRENCY_NAME} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.defaultCurrencyName"} showLabel={true} />
                                            {errors && errors?.[DEFAULT_CURRENCY_NAME] && errors?.[DEFAULT_CURRENCY_NAME]?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.defaultCurrencyReq")}</MotifErrorMessage>}
                                            </div>
                                            <div className="motif-col-lg-3">
                                            <ControlInputBoxNumber name={DEFAULT_EXCHANGE_RATE} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.exchangeRate"} showLabel={true} readonly={true} />
                                            {errors && errors?.[DEFAULT_EXCHANGE_RATE] && errors?.[DEFAULT_EXCHANGE_RATE]?.type==="required" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.defaultExchangeRateReq")}</MotifErrorMessage>}
                                            {errors && errors?.[DEFAULT_EXCHANGE_RATE] && errors?.[DEFAULT_EXCHANGE_RATE]?.type==="validate" && <MotifErrorMessage>{t("pages.caseSetup.currencyConfiguration.defaultExchangeRateNumber")}</MotifErrorMessage>}

                                            </div>
                                            <div className="motif-col-lg-3">
                                            <ControlInputBoxNumber name={DEFAULT_DECIMAL_POINT} control={control} required={true} isTextArea={false} label={"pages.caseSetup.currencyConfiguration.formLabels.decimalPoint"} showLabel={true} readonly={false} isNumber={true} integerOnly={true}  decimalPlace={true}/>
                                           
                                            {errors && errors?.[DEFAULT_DECIMAL_POINT] && errors?.[DEFAULT_DECIMAL_POINT]?.type==="required" && <MotifErrorMessage >{t("pages.caseSetup.currencyConfiguration.defaultDecimalPoint")}</MotifErrorMessage>}
                                            {errors && errors?.[DEFAULT_DECIMAL_POINT] && errors?.[DEFAULT_DECIMAL_POINT]?.type==="validate" && <MotifErrorMessage >{t("pages.caseSetup.currencyConfiguration.defaultDecimalPointNumber")}</MotifErrorMessage>}
                                            </div>
                                            <div className="motif-col-lg-11 mar-t-10">
                                            <ControlInputBox name={DEFAULT_DESCRIPTION} control={control} required={false} isTextArea={true} label={"pages.caseSetup.currencyConfiguration.formLabels.description"} showLabel={true} readonly={false} charLimit={1000}  />
                                           
                                            {errors && errors?.[DEFAULT_DESCRIPTION] && errors?.[DEFAULT_DESCRIPTION]?.type==="required" && <MotifErrorMessage >{t("pages.caseSetup.currencyConfiguration.defaultDecimalPoint")}</MotifErrorMessage>}
                                            {errors && errors?.[DEFAULT_DESCRIPTION] && errors?.[DEFAULT_DESCRIPTION]?.type==="validate" && <MotifErrorMessage >{t("pages.caseSetup.currencyConfiguration.defaultDecimalPointNumber")}</MotifErrorMessage>}
                                            </div>
                                            <div className="motif-col-lg-2">
                                            </div>
                                        </div>
                                    </div>
                                </MotifAccordionContent>
                                </MotifAccordion>
                            </div>
                        </div>
                    </div>
                    <div className="motif-row t-b-padding-21"> 
                        <div className="motif-col-xs-4"> 
                            <div
                            style={{
                                alignItems: 'flex-start',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '15px'
                            }}
                            >
                            
                                <MotifAccordion
                                onClose={()=>{setIsFormOpenOrg(false)}}
                                onOpen={()=>{setIsFormOpenOrg(true)}}
                                style={{
                                    flex: '1'
                                }}
                                open={isFormOpenOrg}
                                useChevronIcon={true}
                                alignIconRight={true}
                                >
                                <MotifAccordionTrigger>
                                    {t("pages.caseSetup.currencyConfiguration.additionalCurrency")}
                                </MotifAccordionTrigger>
                                <MotifAccordionContent>
                                    <div className="motif-container"> 
                                        {controlledFields.map((field, index) => {
                                            return renderCurrencyRow(field, index);
                                        })}     
                                    </div>
                                    
                                    <div className="add-another-btn">
                                        <Button variant={CREATE_BUTTON_VARIANT} label={t("pages.caseSetup.currencyConfiguration.formLabels.addAnother")}  type="button" onClickHandler={addMoreCurrencyRow}/>
                                    </div>
                                </MotifAccordionContent>
                               
                                </MotifAccordion>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div className="button-container sticky-footer"> 
                    <Button label={t("global.globalActions.next")} variant={NEXT_BUTTON_VARIANT}  />
                    <Button label={t("global.globalActions.cancel")} type="button" variant={CANCEL_BUTTON_VARIANT} className="cancelBtn" onClickHandler={()=>{
                        setIsVisible(true);
                        setShowMessage({...showMessage, show: false, type: "error"});
                        dispatch(setDiscardEditMode({ editMode: false }));

                        }}  />
                </div>
                <ConfirmationModal isVisible={isVisible} setIsVisible={setIsVisible} cancelBtnApproveHandler={cancelBtnApproveHandler} cancelBtnRejectHandler={cancelBtnRejectHandler}/>
            </form>
        </>
    );
}